__turbopack_context__.v({
  "__button-group": "modal-container-module-scss-module__iAUVeW____button-group",
  "__close-button": "modal-container-module-scss-module__iAUVeW____close-button",
  "__content": "modal-container-module-scss-module__iAUVeW____content",
  "__header": "modal-container-module-scss-module__iAUVeW____header",
  "__overlay": "modal-container-module-scss-module__iAUVeW____overlay",
  "__text-container": "modal-container-module-scss-module__iAUVeW____text-container",
  "__title": "modal-container-module-scss-module__iAUVeW____title",
  "modal": "modal-container-module-scss-module__iAUVeW__modal",
  "modal-container": "modal-container-module-scss-module__iAUVeW__modal-container",
});
